import { RestError } from "../../services/rest-service/RestService";
import { useMutation } from "react-query";
import { AccessType } from "../../common/enums/DRCXEnums";
import PageConfigurationService from "../../services/page-configuration-service/PageConfigurationService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { useSavePageConfiguration } from "./UseSavePageConfiguration";


export type UseModifyPageConfigurationAccessResultType = {
    oldAccess: AccessType;
    newAccess: AccessType;
}

export type UseModifyPageConfigurationAccessParameters = {
    groupID: number,
    configurationID: number;
} & BaseUseMutationParameters<UseModifyPageConfigurationAccessResultType, AccessType>;

export function useModifyPageConfigurationAccess({
    groupID,
    configurationID,
    onError,
    onSuccess
}: UseModifyPageConfigurationAccessParameters) {

    const { mutateAsync: saveConfiguration } = useSavePageConfiguration({
        groupID
    });

    return useMutation<UseModifyPageConfigurationAccessResultType, RestError, AccessType>(
        async (access) => {

            const model = await PageConfigurationService.getAccessiblePageConfiguration4(groupID as number, configurationID as number);
            const oldAccess = model.access;
            model.access = access;

            await saveConfiguration(model);

            return {
                oldAccess,
                newAccess: access
            }
        },
        {
            onError: onError,
            onSuccess: onSuccess
        }
    );
}
